import React from 'react';

import { FeatureFlags } from '~commonInfra/featureFlags/FeatureFlags';
import { IOAuthCredential } from '~src/connectivity/serverApi/types/OAuth/IOAuthCredential';
import { SessionManagementService } from '~src/sessionManagement/SessionManagementService';
import { ActivityLogSettings } from '~src/settings/IntegrationsSettings/activityLog/ActivityLogSettings';
import { MsTeamsIntegrationSettings } from '~src/settings/IntegrationsSettings/msTeamsConnectivity/MsTeamsIntegrationSettings';
import { SlackIntegrationSettings } from '~src/settings/IntegrationsSettings/slackConnectivity/SlackIntegrationSettings';
import {
  integrationSettingsContainer,
  integrationSpaceContainer
} from '~src/settings/IntegrationsSettings/styles/IntegrationsSettingsStyles';
import { Sites } from '~src/siteManagement/services/resources/Sites';
import { SpacesSiteUrls } from '~src/spacesPlatform/components/spaceComponents/SpacesSiteUrls';
import { ServerSettingsSubspaceName } from '~src/spacesPlatform/state/SpaceInfo';
import { SiteRoles } from '~src/userManagement/users/serverApi/types/ISiteRole';

import { PublishSalesforceBundlesSettings } from './PublishSalesforceBundlesSettings';
import { PublishToSalesforceSettings } from './PublishToSalesforceSettings';

export const IntegrationsSubspaceName: ServerSettingsSubspaceName = 'integrations';

export interface IntegrationsSiteSettingsSubspaceOwnProps {
  readonly siteName: string;
  readonly urls: SpacesSiteUrls;
  readonly server: SessionManagementService;
  readonly isSessionMultiSite: boolean;
  readonly isSessionServerAdmin: boolean;
  readonly isOnlineEnvironment: boolean;
  readonly userRole: String;
  readonly sites: Sites;
}

export type IntegrationsSiteSettingsSubspaceProps = IntegrationsSiteSettingsSubspaceOwnProps;

export interface IntegrationsSiteSettingsSubspaceState {
  readonly credentials: IOAuthCredential[];
}

export class IntegrationsSiteSettingsSubspaceComponent extends React.PureComponent<IntegrationsSiteSettingsSubspaceProps, IntegrationsSiteSettingsSubspaceState> {

  public constructor(props: IntegrationsSiteSettingsSubspaceProps) {
    super(props);
    this.state = {
      credentials: null,
    };
  }

  public async componentDidMount() {
  }

  public render(): JSX.Element {
    return (
      <div className={integrationSpaceContainer}>
        {this.shouldRenderSalesforceIntegrationSettings() && <div className={integrationSettingsContainer}>
          <PublishSalesforceBundlesSettings
            server={this.props.server}
            isOnlineEnvironment={this.props.isOnlineEnvironment}
            urls={this.props.urls}
          />
        </div>}
        {this.shouldRenderPublishToSalesforceSettings() && <div className={integrationSettingsContainer}>
          <PublishToSalesforceSettings server={this.props.server} sites={this.props.sites} />
        </div>}
        {FeatureFlags.userNotificationSlackChannel && <div className={integrationSettingsContainer}>
          <SlackIntegrationSettings />
        </div>}
        {FeatureFlags.msTeamsUserNotification && <div className={integrationSettingsContainer}>
          <MsTeamsIntegrationSettings />
        </div>}
        {<div className={integrationSettingsContainer}>
          <ActivityLogSettings />
        </div>}
      </div>
    );
  }

  private shouldRenderSalesforceIntegrationSettings = (): boolean => {
    const isUserAuthorized: boolean = this.props.userRole === SiteRoles.ServerAdministrator || this.props.userRole === SiteRoles.SiteAdministratorCreator;
    return FeatureFlags.publishingSalesforceBundlesEnabled && isUserAuthorized && this.props.isOnlineEnvironment;
  };

  private shouldRenderPublishToSalesforceSettings = (): boolean => {
    const isUserAuthorized: boolean = this.props.userRole === SiteRoles.ServerAdministrator || this.props.userRole === SiteRoles.SiteAdministratorExplorer || this.props.userRole === SiteRoles.SiteAdministratorCreator;
    return FeatureFlags.publishViewToSalesforce && isUserAuthorized;
  };

}
